var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbtack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 2C8.17894 2 6.5 3.67894 6.5 5.75V6.99695C6.5 8.72083 5.81516 10.3741 4.59619 11.5932L4.21969 11.9696C4.07903 12.1103 4 12.3011 4 12.5V15.25C4 15.6642 4.33579 16 4.75 16H11.25V21.25C11.25 21.6642 11.5858 22 12 22C12.4142 22 12.75 21.6642 12.75 21.25V16H19.25C19.6642 16 20 15.6642 20 15.25V12.5C20 12.3011 19.921 12.1103 19.7803 11.9697L19.4038 11.5932C18.1848 10.3741 17.5 8.72086 17.5 6.99695V5.75C17.5 3.67894 15.8211 2 13.75 2H10.25ZM8 5.75C8 4.50736 9.00736 3.5 10.25 3.5H13.75C14.9927 3.5 16 4.50736 16 5.75V6.99695C16 9.11868 16.8428 11.1535 18.3432 12.6538L18.5 12.8107V14.5H5.5V12.8107L5.65687 12.6538C7.15714 11.1535 8 9.11869 8 6.99695V5.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbtack);
export default __webpack_public_path__ + "static/media/thumbtack.7da7b0c6a1b9d48d2335b6bcb5490163.svg";
export { ForwardRef as ReactComponent };